import { ShowExpert } from "./show-expert";

export default ShowExpert;
